export const customReportGroupingOptions = [
  { id: 'none', name: 'Overall' },
  { id: 'day', name: 'Day' },
  { id: 'week', name: 'Week' },
  { id: 'month', name: 'Month' },
  { id: 'agent', name: 'Agent' },
  { id: 'channel', name: 'Channel' },
  { id: 'status', name: 'Status' },
  { id: 'tag', name: 'Tag' }
];

export const customReportMetricOptions = [
  { id: 'totalConversations', name: 'Total Conversations' },
  { id: 'openConversations', name: 'Open Conversations' },
  { id: 'closedConversations', name: 'Closed Conversations' },
  { id: 'totalMessages', name: 'Total Messages' },
  { id: 'avgMessagesPerConversation', name: 'Avg Messages Per Conversation' },
  { id: 'avgMessagesPerResolvedConversation', name: 'Avg Messages Per Resolved Conversation' },
  { id: 'resolutionRate', name: 'Resolution Rate (%)' }
];

export function normalizeCustomReportGroupingKey(value) {
  const rawValue = typeof value === 'string' ? value.trim() : '';
  for (let i = 0; i < customReportGroupingOptions.length; i = i + 1) {
    if (customReportGroupingOptions[i].id === rawValue) {
      return rawValue;
    }
  }
  return 'day';
}

export function normalizeCustomReportMetricKeys(value) {
  const rawList = Array.isArray(value) === true ? value : [];
  const uniqueMetricKeys = [];
  for (let i = 0; i < rawList.length; i = i + 1) {
    const metricKey = typeof rawList[i] === 'string' ? rawList[i].trim() : '';
    if (metricKey === '') {
      continue;
    }
    const alreadyAdded = uniqueMetricKeys.includes(metricKey);
    if (alreadyAdded === true) {
      continue;
    }
    const isAllowed = customReportMetricOptions.some(option => option.id === metricKey) === true;
    if (isAllowed === true) {
      uniqueMetricKeys.push(metricKey);
    }
  }
  return uniqueMetricKeys;
}

export function getCustomReportGroupingLabel(value) {
  const normalizedValue = normalizeCustomReportGroupingKey(value);
  for (let i = 0; i < customReportGroupingOptions.length; i = i + 1) {
    if (customReportGroupingOptions[i].id === normalizedValue) {
      return customReportGroupingOptions[i].name;
    }
  }
  return 'Day';
}

export function getCustomReportMetricLabels(value) {
  const normalizedMetricKeys = normalizeCustomReportMetricKeys(value);
  const labels = [];
  for (let i = 0; i < normalizedMetricKeys.length; i = i + 1) {
    const match = customReportMetricOptions.find(option => option.id === normalizedMetricKeys[i]);
    if (match !== undefined) {
      labels.push(match.name);
    }
  }
  return labels;
}

export function buildCustomReportDescription(report) {
  const safeReport = report !== null && report !== undefined && typeof report === 'object' ? report : {};
  const groupingLabel = getCustomReportGroupingLabel(safeReport.groupingKey);
  const metricLabels = getCustomReportMetricLabels(safeReport.metricKeys);
  if (metricLabels.length === 0) {
    return groupingLabel;
  }
  return `${groupingLabel} - ${metricLabels.join(', ')}`;
}


